import { defineComponent as y, ref as r, computed as f, onMounted as v } from "vue";
import T, { DropdownMenuItem as E, DropdownMenuTypes as w } from "@ado/dropdown-menu-ld";
import { SequiterButton as D, useNavigationEventBus as I, BUTTON_VARIANTS as N } from "@ado/acs-standard-library";
import { submitInternalEvent as _ } from "@ado/tracking-library";
import { TRACKING_EVENTS as A } from "../../../shared/data/tracking/types/index.js";
import { useBaseApplicationTranslation as M } from "../../../shared/libraries/local-translations/index.js";
import "@ado/acs-standard-library/style.css";
import "@ado/dropdown-menu-ld/style.css";
const q = y({
  name: "CountrySelectorMore",
  components: {
    DropdownMenu: T,
    SequiterButton: D
  },
  props: {
    countries: {
      type: Array,
      required: !0
    },
    currentCountry: {
      type: Object,
      required: !0
    }
  },
  setup(n) {
    const s = r(!1), e = r(n.currentCountry), a = w, c = N, i = I(), u = r(!1), m = f(() => [...n.countries].sort((t, o) => t.name.localeCompare(o.name)).map(
      (t) => E.newCustomItem(
        t.countryCode,
        "country-dropdown-menu-item",
        t
      )
    )), p = (t) => {
      const o = {
        ...A.HEADER_COUNTRY_DROPDOWN_CLICK,
        extra: t
      };
      _(o);
    }, l = (t) => {
      e.value = t, u.value = !1, p(t.name);
    }, d = () => {
      i.navigate(e.value.canonicalUrl);
    }, { t: C } = M();
    return v(() => {
      e.value = n.currentCountry;
    }), {
      dialogVisible: s,
      selectedCountry: e,
      menuTypes: a,
      buttonVariants: c,
      countryMenuItems: m,
      setSelectedCountry: l,
      selectedCountryLink: d,
      showDropdownCountries: u,
      t: C
    };
  }
});
export {
  q as default
};
//# sourceMappingURL=index7.js.map
